/**
 * 服务费账户
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { XInput, XOKButton, XCancelButton, XDatePicker } from '@/components/xqxc_ui';
import { connect } from 'react-redux';
import TableList from './components/TableList';
import model from '@/reducers/finance/taxdeclaration/model';
import KeepAlive from '@/routes/KeepAlive';
import { SearchBox, SearchItem } from '@/components/Layout';
import { autoPageNum, autopageSize } from '@/assets/config';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

class Main extends React.Component {

    state = {
        name: null,
        startTime: undefined,
        endTime: undefined,
        pageNum: 1,
        pageSize: 10,
    }

    componentDidMount() {
        this.props.setBreadcrumbPaths(this.props.match);
    }

    // 查询
    _searchHandle = (useCache) => {
        const { name, startTime, endTime, pageNum, pageSize } = this.state;
        this.searchCache = {
            name,
            startTime,
            endTime,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getTableSource(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }

    // 重置
    _resetHandle = () => {
        this.setState({ name: null, startTime: undefined, endTime: undefined, pageNum: 1, pageSize: 10 }, () => {
            KeepAlive.saveResetFunc(this._searchHandle); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }

    // 新建广告
    _newHandle = () => {

    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageNum, pageSize }, () => {
            this._searchHandle('useCache');
        });
    }

    render() {
        const { name, startTime, endTime } = this.state;
        const { tableSource } = this.props;
        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: '200px' }}
                                label='姓名'
                                placeholder='请输入'
                                value={name}
                                bindThis={this}
                                bindName='name'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XDatePicker
                                label='所得时间'
                                datePickerStyle={{ width: 200 }}
                                value={startTime}
                                bindThis={this}
                                bindName='startTime'
                                isFormat
                            />
                            <XDatePicker
                                style={{ marginRight: 20 }}
                                datePickerStyle={{ width: 200 }}
                                label=''
                                value={endTime}
                                bindThis={this}
                                bindName='endTime'
                                isFormat
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <div className={styles.row2}>
                        <XOKButton
                            style={{ width: '120px' }}
                            label='生成报表'
                            onClick={this._newHandle}
                        />
                    </div>
                    <TableList renderData={tableSource} paginationChange={this._paginationChange} />
                </div>
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
    match: PropTypes.func,
    getTableSource: PropTypes.func,
    tableSource: PropTypes.object,
    setBreadcrumbPaths: PropTypes.func
};
const mapStateToProps = (state) => ({
    tableSource: state.taxdeclaration.tableSource,
});

export default connect(mapStateToProps, { ...model.actions, setBreadcrumbPaths })(Main);